import { Component, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { LoaderService } from '@service';

@Component({
  selector: 'bmd-loader',
  // eslint-disable-next-line @angular-eslint/prefer-standalone
  standalone: false,
  styleUrls: ['./loader.component.scss'],
  templateUrl: './loader.component.html',
})
export class LoaderComponent implements OnInit, OnDestroy {
  constructor(
    public loaderService: LoaderService,
    private readonly self: ElementRef<LoaderComponent>,
  ) {}

  ngOnDestroy(): void {
    this.loaderService.unregisterLoader(this.self);
  }

  ngOnInit(): void {
    this.loaderService.registerLoader(this.self);
  }
}
